import React from "react"

import InducedComponent from './induced-component'

import { connect } from 'react-redux'

import PPIInvestmentProjectService from '../../../../service/sfp/ppi-investment-project-service'

class InducedContainer extends React.Component {

    state = {
        accounts: [],
        loading: false,
        notFound: false,
        induceds: []
    }

    componentWillMount() {
        this.setState({ induceds: this.props.project.induceds })
    }

    componentDidMount() {
        var accounts = this.props.currentLocalAuthority.accounts
        accounts = accounts.sort((a, b) => (a.account.number.toString() > b.account.number.toString() ? 1 : -1))
        this.setState({ accounts: this.props.currentLocalAuthority.accounts })
        /*, () => {
            InducedAccountService.getAllInducedAccounts()
                .then(::this._resolveGetInducedAccounts, ::this._rejectGetInducedAccounts);
        })*/
    }

    render() {
        return (
            <InducedComponent
                loading={this.state.loading}
                submitting={this.state.submitting}
                accounts={this.state.accounts}
                induceds={this.state.induceds}
                onInducedCreate={this._handleInducedCreate.bind(this)}
                onInducedChange={this._handleInducedChange.bind(this)}
                onInducedRemove={this._handleInducedRemove.bind(this)}
                onSave={this._handleSave.bind(this)}
            />
        )
    }

    _handleInducedCreate(data) {
        var induceds = this.state.induceds
        induceds.push(data)
        var state = { induceds }
        this.setState(state)
    }

    _handleInducedChange(id, data) {
        var induced = this.state.induceds.find(i => i.id == id)
        induced.gain = data.gain
        induced.loss = data.loss
        induced.year = data.year
        this.setState(this.state)
    }

    _handleInducedRemove(id) {
        const induceds = this.state.induceds
        const index = induceds.findIndex(item => item.id == id)
        induceds.splice(index, 1)
        this.setState({ induceds })
    }

    _handleSave() {
        this.setState({ submitting: true }, () => {
            PPIInvestmentProjectService.updatePPIInvestmentProject(
                this.props.project.id,
                {
                    "induceds": this.state.induceds.map(i => {
                        var data = {
                            gain: i.gain,
                            loss: i.loss,
                            year: i.year,
                            induced: i.induced.id,
                            project: this.props.project.id
                        }
                        if (typeof i.id !== 'string' && !(i.id instanceof String)) {
                            if (i.deleted) data.project = null
                            else data["id"] = i.id
                        } else {
                            //data = undefined
                        }
                        return data
                    }).filter(i => i !== undefined)
                }
            )
                .then(this._resolveUpdateInvestmentProject.bind(this, event), this._rejectUpdateInvestmentProject)
        })
    }

    _rejectUpdateInvestmentProject = (error) => {
        this.props.actions.throwError(error)
        this.setState({ error, submitting: false })
    }

    _resolveUpdateInvestmentProject = (
	/** @type {React.SyntheticEvent<Element>} */ event,
	/** @type {Object} */               response) => {
        //event.target.reset()
        this.setState({ submitting: false }, () => {
            this.props.onSave(response)
        })
    }

}

const mapStateToProps = (state) => ({
    currentLocalAuthority: state.currentLocalAuthority
})

export default connect(mapStateToProps)(InducedContainer)



// WEBPACK FOOTER //
// ./src/component/ppi/ppi-detail/investments/induced-container.js